import { ResendConfirmationEmailMessages, TranslationResendConfirmationEmailMessages } from "@languages/interfaces";

export const messages: TranslationResendConfirmationEmailMessages = {
  [ResendConfirmationEmailMessages.resendConfirmationEmailRequiredEmail]: "Correo electrónico es obligatorio",
  [ResendConfirmationEmailMessages.resendConfirmationEmailInvalidEmail]: "Correo electrónico inválido",
  [ResendConfirmationEmailMessages.resendConfirmationEmailTitlePage]: "Reenviar correo electrónico de confirmación",
  [ResendConfirmationEmailMessages.resendConfirmationEmailLabel]: "Correo electrónico",
  [ResendConfirmationEmailMessages.resendConfirmationEmailButton]: "Enviar correo electrónico"
};